import { NError, NSuccess } from '@src/configs/const.config'
import { checkAuth } from '@libs/localStorage'
import { TResApi, TResApiErr } from '@src/configs/interface.config'
import {
  TAppConfig,
  TCreateAppConfig,
  TQueryAppConfig,
  TUpdateAppConfig,
} from '@src/modules'
import { notification } from 'antd'
import { useMutation, useQuery } from 'react-query'

import {
  createAppConfig,
  deleteAppConfig,
  getAppConfigs,
  patchAppConfig,
} from '../apis/app-config'

import { queryClient } from '..'

export const APP_CONFIG_LIST = 'APP_CONFIG_LIST'

export const useAppConfigs = (params: TQueryAppConfig) => {
  const token = checkAuth()
  return useQuery<TResApi<TAppConfig[]>>(
    [APP_CONFIG_LIST, params],
    () => getAppConfigs(params, token),
    { enabled: !!token, keepPreviousData: true },
  )
}

export const useCreateAppConfig = () => {
  const token = checkAuth()
  return useMutation(
    (data: TCreateAppConfig) => createAppConfig(data, token),
    {
      onSuccess: (res: TResApi<TAppConfig>) => {
        queryClient.invalidateQueries([APP_CONFIG_LIST])
        notification.success({ message: NSuccess, description: res?.message })
      },
      onError: (error: TResApiErr) =>
        notification.error({ message: NError, description: error?.message }),
    },
  )
}

export const useUpdateAppConfig = () => {
  const token = checkAuth()
  return useMutation(
    ({ id, data }: { id: number; data: TUpdateAppConfig }) =>
      patchAppConfig(id, data, token),
    {
      onSuccess: (res: TResApi<TAppConfig>) => {
        queryClient.invalidateQueries([APP_CONFIG_LIST])
        notification.success({ message: NSuccess, description: res?.message })
      },
      onError: (error: TResApiErr) =>
        notification.error({ message: NError, description: error?.message }),
    },
  )
}

export const useDeleteAppConfig = () => {
  const token = checkAuth()
  return useMutation((id: number) => deleteAppConfig(id, token), {
    onSuccess: (res: TResApi<unknown>) => {
      queryClient.invalidateQueries([APP_CONFIG_LIST])
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) =>
      notification.error({ message: NError, description: error?.message }),
  })
}
